module.exports = __webpack_public_path__ + "static/media/lonely-cat.fc757dd3.svg";